import React, { PureComponent } from "react";
import { Collapse } from 'reactstrap';
import "./PetPlanCollapse.component.css";

class PetPlanCollapse extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { collapse: false };
    }

    toggle = () => {
        this.setState({ collapse: !this.state.collapse });
    }
    render() {
        const { MonthlyPremium, Name, Reimbursement, Deductible, AnnualLimit } = this.props.plan


        return (
            <div className="d-inline col-md-6 pet-plan-collapse">
                <div className="px-2 align-top">
                    <div className="mb-3 pet-list-panel-container">
                        <div className="row p-3 overflow-hidden pet-list-panel">
                            <div className="col-12">
                                <div className="pet-plan-header">
                                    <div className="font-weight-bold mb-2 pet-name-header"><span className="pet-name-ellipsis">{Name}</span>'s Plan</div>
                                    <table className="coverage-table">
                                        
                                        <tr>
                                            <td><span className="coverage-table-label">Maximum Annual Payout:</span></td>
                                            <td> {
                                                AnnualLimit?.toLowerCase().includes('unlimited')
                                                    ? AnnualLimit.replace(/\$/g, '').trim()
                                                    : AnnualLimit
                                            }</td>
                                        </tr>
                                        <tr>
                                            <td><span className="coverage-table-label">Reimbursement:</span></td>
                                            <td>{Reimbursement}</td>
                                        </tr>
                                        <tr>
                                            <td><span className="coverage-table-label">Annual Deductible:</span></td>
                                            <td>{Deductible}</td>
                                        </tr>
                                    </table>
                                    <div className="font-weight-bold premium-text">{MonthlyPremium}<small className="month-text">/month</small></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

export default PetPlanCollapse;